import React, { useEffect, useState } from "react";
import { Dropdown, Table } from "antd";
import {
  AiOutlineMore,
  AiOutlineFileText,
  AiOutlineSend,
  AiOutlineInfoCircle,
  AiOutlineFilePdf,
} from "react-icons/ai";

import * as S from "../style";
import { TCanceledInsurances } from "./types";
import { TInsurance } from "../ActiveInsurances/types";
import { getInsuranceColumns } from "../ActiveInsurances/constants";

export const CanceledInsurances: React.FC<TCanceledInsurances> = ({
  insurances,
  handleModalAdhesionAgreement,
  printTicketInsurance,
  handleClickSendEmail,
  openDetailModal,
}) => {
  const [totalInsurance, setTotalInsurance] = useState<number>(0);

  const getMenu = (insurance: TInsurance) => {
    const menuItems = [];

    if (insurance.possuiBilhete) {
      menuItems.push(
        <S.StyledMenuItem
          key="emitirBilhete"
          onClick={() => printTicketInsurance(insurance)}
        >
          <AiOutlineFilePdf size={20} /> Emitir bilhete
        </S.StyledMenuItem>
      );
    }

    if (insurance.possuiTermoAdesao) {
      menuItems.push(
        <S.StyledMenuItem
          key="emitirTermo"
          onClick={() => handleModalAdhesionAgreement(insurance)}
        >
          <AiOutlineFileText size={20} /> Emitir termo de adesão
        </S.StyledMenuItem>
      );
    }

    menuItems.push(
      <S.StyledMenuItem
        key="enviar"
        onClick={() => handleClickSendEmail(insurance)}
      >
        <AiOutlineSend size={20} /> Enviar
      </S.StyledMenuItem>
    );

    menuItems.push(
      <S.StyledMenuItem
        key="informacoes"
        onClick={() => openDetailModal(insurance)}
      >
        <AiOutlineInfoCircle size={20} /> Informações
      </S.StyledMenuItem>
    );

    return <S.StyledMenu>{menuItems}</S.StyledMenu>;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderActions = (record: any) => {
    return (
      <S.InsuranceActions>
        <Dropdown
          overlay={getMenu(record.originalData)}
          trigger={["click"]}
          placement="bottomRight"
        >
          <AiOutlineMore className="custom-icon" />
        </Dropdown>
      </S.InsuranceActions>
    );
  };

  const tableData = insurances.map((insurance: TInsurance) => ({
    key: insurance.codigoAdesao,
    codigo: insurance.codigoAdesaoDependente || insurance.codigoAdesao,
    descricao: insurance.produto.descricao,
    valor: parseFloat(insurance.valor),
    originalData: insurance,
  }));

  useEffect(() => {
    const calculateTotalInsurance = () => {
      let totalSum = 0;
      insurances.forEach((seguro) => {
        const valor = parseFloat(
          seguro.valor.replace("R$ ", "").replace(",", ".")
        );
        totalSum += valor;
      });
      setTotalInsurance(totalSum);
    };
    calculateTotalInsurance();
  }, [insurances]);

  const CanceledInsurancesColumns = getInsuranceColumns(renderActions, "C");
  return (
    <div>
      <Table
        columns={CanceledInsurancesColumns}
        dataSource={tableData}
        scroll={{ y: 200 }}
        pagination={{ pageSize: 3, showSizeChanger: false }}
      />

      {insurances.length > 0 && (
        <S.TotalInsuranceInfo>
          <p>Total</p>
          <h2>R$ {totalInsurance.toFixed(2)}</h2>
        </S.TotalInsuranceInfo>
      )}
    </div>
  );
};
